module.exports = __webpack_public_path__ + "static/media/5.b3e6143f.jpg";